import { render } from "./BetaOverlay.vue?vue&type=template&id=0d18225e&ts=true"
import script from "./BetaOverlay.vue?vue&type=script&lang=ts"
export * from "./BetaOverlay.vue?vue&type=script&lang=ts"

import "./BetaOverlay.vue?vue&type=style&index=0&id=0d18225e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__